export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10868.32822c52.jpg";